import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NasModelModule } from '@sama/ng-app-state';
// eslint-disable-next-line import-whitelist -- allow this until component is moved to core
import { CameraCalibrationPopoverComponent } from '../../3d/toolbars/projection-settings-toolbar/camera-calibration-popover.component';
import { CrossTeamSharedModule } from '../../cross-team-shared/cross-team-shared.module';
import { MessageModalComponent } from '../../cross-team-shared/misc-services/message-modal/message-modal.component';
import { H3DatePipe } from '../../shared/pipes-and-filters/h3-date.pipe';
import { CalibrationSettingsButtonComponent } from '../outputs/annotation/annotation-shared/toolbars/static-toolbar/calibration-settings-button/calibration-settings-button.component';
import { EnhancedPointCloudSettingsComponent } from '../outputs/annotation/annotation-shared/toolbars/static-toolbar/enhanced-point-cloud-settings/enhanced-point-cloud-settings.component';
import { SubmissionsNavigationComponent } from '../read-only-workspace/navbar/submissions-navigation/submissions-navigation.component';
import { SubmitterInfoComponent } from '../read-only-workspace/navbar/submitter-info/submitter-info.component';
import { ClientBatchIdComponent } from './client-id/client-batch-id.component';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { DebugLoggingButtonComponent } from './debug-logging/debug-logging-button.component';
import { DebugLogIdComponent } from './debug-logging/modals/debug-log-id.component';
import { FlagTechnicalIssueModalComponent } from './debug-logging/modals/flag-technical-issue-modal.component';
import { StartDebugLoggingModalComponent } from './debug-logging/modals/start-debug-logging-modal.component';
import { DecisionMessageModalComponent } from './decision-message-modal/decision-message-modal.component';
import { BrowserZoomTrackingComponent } from './event-tracking/browser-zoom-tracking/browser-zoom-tracking.component';
import { TrackAsDirective } from './event-tracking/event-tracking.directive';
import { PageScrollTrackingComponent } from './event-tracking/scroll-tracking/page-scroll-tracking.component';
import { LinkedRadioButtonDropdownComponent } from './navbar/linked-radio-button-dropdown/linked-radio-button-dropdown.component';
import { NavbarProjectStatusIndicatorComponent } from './navbar/navbar-project-status-indicator/navbar-project-status-indicator.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NavigationBreadcrumbsComponent } from './navbar/navigation-breadcrumbs/navigation-breadcrumbs.component';
import { SamaLogoComponent } from './navbar/sama-logo/sama-logo.component';
import { SavingIndicatorComponent } from './navbar/saving-indicator/saving-indicator.component';
import { StepsNavigationComponent } from './navbar/steps-navigation/steps-navigation.component';
import { PageLoadingOverlayComponent } from './page-loading-overlay/page-loading-overlay.component';
import { LoadingOverlayComponent } from './progress-utilities/loading-overlay.component';
import { CommentEditorComponent } from './qa-feedback/comment-editor.component';
import { TaskIdComponent } from './task-id/task-id.component';
import { ViewContainerDirective } from './view-container-mapping/view-container.directive';

const exportedItems = [
  BrowserZoomTrackingComponent,
  ContextMenuComponent,
  CommentEditorComponent,
  DecisionMessageModalComponent,
  H3DatePipe,
  LoadingOverlayComponent,
  MessageModalComponent,
  NavbarComponent,
  PageScrollTrackingComponent,
  PageLoadingOverlayComponent,
  DebugLoggingButtonComponent,
  StartDebugLoggingModalComponent,
  FlagTechnicalIssueModalComponent,
  DebugLogIdComponent,
  SamaLogoComponent,
  SavingIndicatorComponent,
  StepsNavigationComponent,
  SubmissionsNavigationComponent,
  TrackAsDirective,
  ViewContainerDirective,
  CalibrationSettingsButtonComponent,
  CameraCalibrationPopoverComponent,
  EnhancedPointCloudSettingsComponent,
];

@NgModule({
  imports: [
    CommonModule,
    CrossTeamSharedModule,
    FontAwesomeModule,
    FormsModule,
    NasModelModule,
    NgOptimizedImage,
    ReactiveFormsModule,
    MatButtonModule,
    MatChipsModule,
    MatDialogModule,
    MatExpansionModule,
    MatMenuModule,
    MatRadioModule,
    MatTooltipModule,
    OverlayModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatProgressSpinnerModule,
    MatSelectModule,
  ],
  declarations: [
    exportedItems,
    LinkedRadioButtonDropdownComponent,
    NavbarProjectStatusIndicatorComponent,
    NavbarProjectStatusIndicatorComponent,
    TaskIdComponent,
    SubmitterInfoComponent,
    NavigationBreadcrumbsComponent,
    ClientBatchIdComponent,
  ],
  exports: [exportedItems, CrossTeamSharedModule],
})
export class SharedModule {}
